import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../ui/select'
import type { UrlStateAdapter } from './filters/urlAdapter'

export default function ProductSort({ adapter }: { adapter?: UrlStateAdapter } = {}) {
  if (adapter) {
    return <ProductSortInner adapter={adapter} />
  }
  return <ProductSortReactRouter />
}

function ProductSortReactRouter() {
  const [rrParams, setRrParams] = useSearchParams()
  const adapter: UrlStateAdapter = {
    searchParams: rrParams,
    setSearchParams: (next) => setRrParams(next),
  }
  return <ProductSortInner adapter={adapter} />
}

function ProductSortInner({ adapter }: { adapter: UrlStateAdapter }) {
  const { searchParams, setSearchParams } = adapter
  const { t } = useTranslation()
  const current = searchParams.get('sort') ?? 'relevance'

  const SORT_OPTIONS = [
    { value: 'relevance', label: t('product.sortRelevance') },
    { value: 'name_asc', label: t('product.sortNameAsc') },
    { value: 'name_desc', label: t('product.sortNameDesc') },
    { value: 'price_asc', label: t('product.sortPriceAsc') },
    { value: 'price_desc', label: t('product.sortPriceDesc') },
  ]

  function handleChange(value: string) {
    const next = new URLSearchParams(searchParams)
    if (value === 'relevance') {
      next.delete('sort')
    } else {
      next.set('sort', value)
    }
    next.delete('page')
    setSearchParams(next)
  }

  return (
    <div className="flex items-center gap-2">
      <label id="product-sort-label" className="text-sm text-neutral-600 whitespace-nowrap">{t('product.sortLabel')}</label>
      <Select value={current} onValueChange={handleChange}>
        <SelectTrigger className="w-44 h-9 text-sm" aria-label={t('product.sortLabel')}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {SORT_OPTIONS.map(opt => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
